import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FormSection, change } from 'redux-form';
import DayPickerInputField from './DayPickerInputField';

const statuses = [
  'Not Started',
  'In Progress',
  'Blocked',
  'Finished',
];

@connect()
export default class TaskStatusEditor extends Component {
  componentDidMount = () => {
    const { uid, dispatch, input } = this.props;
    if (!input.value.status || typeof input.value !== 'object') {
      dispatch(change(uid, `${input.name}.status`, 'Not Started'));
    }
  }

  handleStartDateChange = dateValue => {
    const { uid, dispatch, input } = this.props;
    dispatch(change(uid, `${input.name}.startDate`, dateValue));
  }

  handleFinishDateChange = dateValue => {
    const { uid, dispatch, input } = this.props;
    dispatch(change(uid, `${input.name}.finishDate`, dateValue));
  }

  handleStatusOnChange = value => {
    const { uid, dispatch, input } = this.props;
    const typeOptions = this.props.inlineTypeOptions || this.props.propTypeOptions;
    dispatch(change(uid, `${input.name}.status`, value));
    if (value === 'Not Started') {
      dispatch(change(uid, `${input.name}.startDate`, input.value.startDate || new Date()));
    } else if (value === 'In Progress') {
      dispatch(change(uid, `${input.name}.startDate`, input.value.startDate || new Date()));
    } else if (value === 'Finished') {
      dispatch(change(uid, `${input.name}.startDate`, input.value.startDate || new Date()));
      dispatch(change(uid, `${input.name}.finishDate`, input.value.finishDate || new Date()));
    } else if (value === 'Blocked') {
      dispatch(change(uid, `${input.name}.startDate`, input.value.startDate || new Date()));
      dispatch(change(uid, `${input.name}.reason`, typeOptions.reasons[0]));
    }
  }

  getBonusField = () => {
    const { input } = this.props;
    const typeOptions = this.props.inlineTypeOptions || this.props.propTypeOptions;
    const fieldValue = input.value;

    const startDateField = (
      <div>
       <label
          className="mt-1 mb-0"
          style={{ fontFamily: 'Arial', fontSize: 14 }}
        >
          Start Date
        </label>
        <div className="input-group">
          <Field
            component={DayPickerInputField}
            name="startDate"
            value={fieldValue.startDate}
            dateChange={this.handleStartDateChange}
          />
        </div>
      </div>
    );

    const finishDateField = (
      <div>
        <label
          className="mt-1 mb-0"
          style={{ fontFamily: 'Arial', fontSize: 14 }}
        >
          Finish Date
        </label>
        <div className="input-group">
          <Field
            component={DayPickerInputField}
            name="finishDate"
            value={fieldValue.finishDate}
            dateChange={this.handleFinishDateChange}
          />
        </div>
      </div>
    );

    switch (fieldValue.status) {
      case 'Blocked': {
        const editorReason = fieldValue.reason;
        return (
          <div>
            <label
              className="mt-1 mb-0"
              style={{ fontFamily: 'Arial', fontSize: 14 }}
            >
              Reason
            </label>
            <div className="input-group">
              <Field
                component="select"
                className="form-control c-select d-inline-block"
                name="reason"
                value={editorReason}
              >
                {typeOptions &&
                  typeOptions.reasons &&
                  typeOptions.reasons.map(o =>
                    <option key={o} value={o}>{o}</option>,
                  )}
              </Field>
            </div>
            {startDateField}
          </div>
        );
      }
      case 'Not Started':
        return (
          <div>
            {startDateField}
          </div>
        );
      case 'In Progress':
        return (
          <div>
            {startDateField}
          </div>
        );
      case 'Finished':
        return (
          <div>
            {startDateField}
            {finishDateField}
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const { designerMode, input } = this.props;
    // const typeOptions = this.props.inlineTypeOptions || this.props.propTypeOptions;
    const formSectionName = designerMode ? 'propValue' : 'field';
    const fieldValue = input.value;
    const editorStatus = (fieldValue && fieldValue.status) || null;
    const bonusField = editorStatus ? this.getBonusField() : null;

    return (
      <FormSection name={formSectionName}>
        <div className="input-group">
          <Field
            component="select"
            className="form-control c-select d-inline-block"
            name="status"
            value={editorStatus}
            onChange={e => {
              this.handleStatusOnChange(e.target.value);
            }}
          >
            {statuses.map(o =>
              <option key={o} value={o}>{o}</option>,
            )}
          </Field>
        </div>
        {bonusField}
      </FormSection>
    );
  }
}

TaskStatusEditor.propTypes = {
  // typeOptions: PropTypes.object,
  inlineTypeOptions: PropTypes.object,
  propTypeOptions: PropTypes.object,
  field: PropTypes.object,
  input: PropTypes.object,
  dispatch: PropTypes.func,
  uid: PropTypes.string,
  designerMode: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/types/TaskStatus/TaskStatusEditor.js